import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const timelineData = [
    {
    company: "Inari Medical Inc",
    role: "Software Automation Engineer",
    location: "6001 Oak Canyon Ste. 100, Irvine, CA 92618",
    dates: "May 2022- Current",
    image: "inari_medical_logo.png",
  },
  {
    company: "Tech Mahindra",
    role: "Sr Software Engineer",
    location: "5850 Granite Pkwy Suite 1200, Plano, TX 75024",
    dates: "Aug 2021 - Mar 2022",
    image: "/techm.jpg",
  },
  {
    company: "Param Labs",
    role: "Data Scientist - Engineer",
    location: "Silicon Oasis, Dubai, United Arab Emirates (UAE)",
    dates: "Aug 2018 - May 2021",
    image: "/plabs.png",
  },
  {
    company: "LZine",
    role: "Data Analytics - Engineer",
    location: "24R8+7JH - Village - Dubai - UAE",
    dates: "Oct 2016 - July 2018",
    image: "/Lzine.jpg",
  },
];

const CareerTimeline = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 480);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "2rem 1rem" }}>
      {timelineData.map((entry, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: index * 0.2 }}
          style={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            marginBottom: "2rem",
            padding: "1.5rem",
            textAlign: "left",
          }}
        >
          {index === 0 && (
            <h2
              style={{
                marginBottom: "1rem",
                fontSize: "2rem",
                fontWeight: "700",
                color: "#222",
              }}
            >
              Career Timeline
            </h2>
          )}

          <div
            style={{
              width: "100%",
              textAlign: "left",
              marginBottom: "1rem",
              borderRadius: "10px",
              overflow: "visible",
            }}
          >
            <img
              src={entry.image}
              alt={entry.company}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "10px",
              }}
            />
          </div>

          <div style={{ padding: "0 0.5rem" }}>
            <p
              style={{
                fontWeight: "700",
                fontSize: "1.2rem",
                marginBottom: "0.25rem",
                color: "#111",
              }}
            >
              {entry.company}
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "600",
                fontSize: isMobile ? "0.9rem" : "1.05rem",
                color: "#666",
                marginBottom: "0.5rem",
                flexWrap: "wrap",
                gap: "0.5rem",
              }}
            >
              <span style={{ flex: "1 1 auto", minWidth: 0 }}>{entry.role}</span>
              <span style={{ flexShrink: 0 }}>{entry.dates}</span>
            </div>

            <p
              style={{
                margin: "0.25rem 0",
                fontSize: "0.95rem",
                color: "#444",
                fontStyle: "italic",
              }}
            >
              {entry.location}
            </p>

          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default CareerTimeline;
